/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { isArray, TranslateModule, TranslateService } from '@ngx-translate/core';
import { curitibaPrivacyPolicy, privacyPolicy } from './static-legal-texts.component';
import { RestService } from 'src/app/services/rest.service';

@Component({
    selector: 'legal-texts',
    standalone: true,
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule
    ],
    templateUrl: './legal-texts.component.html',
    styleUrls: ['./legal-texts.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class LegalTextsComponent {
    @ViewChild('legalTextEl', { static: true }) legalTextEl!: ElementRef;
    @Input('type') type = 'privacy_policy';

    private modalController = inject(ModalController);
    private restService = inject(RestService);
    private translate = inject(TranslateService);
    private readonly CURITIBA = 45;

    public title: string;
    public legalText: string;

    ngOnInit(){
        this.title = null;
        this.legalText = null;
        switch(this.type){
            case 'privacy_policy': this.loadPrivacyText(); break;
        }

        if(!this.legalText)
            this.dismissModal();
    }

    ngAfterViewInit() {
        this.updateAnchorTargets();
    }

    loadPrivacyText(){
        if (!this.restService?.device?.privacyPolicy || !isArray(this.restService?.device?.privacyPolicy) || this.restService?.device?.privacyPolicy?.length === 0){
            this.title = this.translate.instant('Política de Privacidad');
            this.legalText = privacyPolicy?.[this.translate.currentLang] || null;
            this.checkCuritiba();
            return;
        }

        const policy = this.restService?.device?.privacyPolicy?.find(privacy => privacy.type === 'privacy_policy');
        this.title = policy?.title?.[this.translate.currentLang] || this.translate.instant('Política de Privacidad');        
        this.legalText = policy?.content?.[this.translate.currentLang] || privacyPolicy?.[this.translate.currentLang] || null;
        this.checkCuritiba();
    }

    checkCuritiba(){
        if (this.restService?.device?.client !== this.CURITIBA)
            return;

        this.title = this.translate.instant('Política de Privacidad');
        this.legalText = curitibaPrivacyPolicy?.[this.translate.currentLang] || null;
        
    }

    updateAnchorTargets() {
        const anchors = this.legalTextEl.nativeElement.querySelectorAll('a');
        anchors.forEach((a: HTMLAnchorElement) => {
          a.setAttribute('target', '_blank');
          a.setAttribute('rel', 'noopener noreferrer'); // 🔒 seguridad recomendada
        });
      }

    dismissModal(){
        this.modalController.dismiss().catch(e => {
            console.warn("No modal found on dismiss")
        });
    }
}